import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    dashboardNotification: null,
}

export const dashboard = createSlice({
    name: 'dashboard',
    initialState,
    reducers: {
        set_dashboardNotification: (state, action) => {
            console.log("🚀 ~ action:", action.payload)
            return ({
                ...state,
                dashboardNotification: action.payload
            })
        },
    }
})

export const { set_dashboardNotification } = dashboard.actions
export default dashboard.reducer